export default function HideBasket() {
  $('.basket-holder').removeClass('hover');
  $('body').removeClass('basket-opened');
  $(".confirm-tooltip").removeClass("active");
}